import { render, staticRenderFns } from "./EntranceTeacherHistoryHeader.vue?vue&type=template&id=191fb9eb&scoped=true&lang=pug&"
import script from "./EntranceTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./EntranceTeacherHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceTeacherHistoryHeader.vue?vue&type=style&index=0&id=191fb9eb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191fb9eb",
  null
  
)

export default component.exports